import gql from 'graphql-tag';

export const GET_USER_GENERATED_CONTENT_COLLECTION = gql`
  query GetUserGeneratedContentCollection($id: String!) {
    userGeneratedContentCollection(id: $id) {
      title
      trackingEvent
      subtitle
      entries {
        title
        id
        creator
        creatorProfilePhoto {
          alt
          url
        }
        image {
          alt
          url
        }
      }
    }
  }
`;
